import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { BASE_URL } from "../../../utils/Constants";
import Swal from "sweetalert2";
import AuthContext from "../../../store/auth-context";
import "./Courses.css"

const Courses = () => {
    const [courses, setCourses] = useState([]);
    const [allCourses, setAllCourses] = useState([]);
    const [lastViewedLesson, setLastViewedLesson] = useState<any>();
    const AuthCtx = useContext(AuthContext)
    useEffect(() => {
        Swal.showLoading()
        
        axios.get(`${BASE_URL}/course/getcourses.php`).then((res: any) => {
            setCourses(res.data.data.courses)
            setAllCourses(res.data.data.allcourses)
            setLastViewedLesson(res.data.data.last_viewed_lesson)
            Swal.close()
        }).catch((err) => {
            
            // AuthCtx.Logout()
            Swal.close()
        })
    }, []);
    function goToWhatsapp(msg:any){
          
    
        // href="https://web.whatsapp.com/send?phone=201012529458&text=السلام عليكم كان عندي استفسار بخصوص---"
        let whatsapp_link="";
        let checkDevice = "mobile";
        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if(window.innerWidth > 700) checkDevice ="desktop";
    
        if(checkDevice == "mobile" || isMobile){
    
          whatsapp_link = `https://chatapp.online/wa-redirect/?phone=201033226542&text=${msg}`
        }else {
          whatsapp_link = `https://web.whatsapp.com/send?phone=+201033226542&text=${msg}`
    
        }
    
       window.open(whatsapp_link )
      }

    return (
        <div>
            <section className="section products  background-light"
                kjb-settings-id="sections_1596053467662_settings_background_color">
                <div className="sizer">

                    <div className="container">
                        <div className="row products__list">
                            <div className="col-12 products__col">
                                <div className="products__header">
                                    <h3 className="products__title"
                                        kjb-settings-id="sections_1596053467662_settings_text_heading">My Courses
                                    </h3>




                                    {lastViewedLesson?.name ? (
                                        <div className="resume-course box-shadow-none  background-light">
                                            <div className="resume-course__positioner">




                                                <NavLink className="resume-course__content"
                                                    to={`/lesson?id=${lastViewedLesson.lesson_id}&module_id=${lastViewedLesson.module_id}`}>
                                                    <div className="resume-course__text">
                                                        <p className="h6 resume-course__status"
                                                            kjb-settings-id="sections_1596053467662_settings_resume">
                                                            Resume Course : {lastViewedLesson?.name}</p>
                                                        <p className="resume-course__title"> {lastViewedLesson?.module_name} - {lastViewedLesson?.lesson_name}</p>

                                                    </div>
                                                    <div className="resume-course__image">

                                                        <img

                                                            src={`${BASE_URL}/images/${lastViewedLesson?.lesson_image_path}`} />

                                                    </div>
                                                </NavLink>





                                            </div>
                                        </div>

                                    ) : ""}

                                </div>
                            </div>




                            {courses?.map((course: any , index: number) => {
                                
                                return (
                                    <div className="col-12 products__col" key={index}>


                                        <div className="product product--12 box-shadow-medium  background-light">

                                            <NavLink className=""
                                                to={`/course?id=${course.id}`}>
                                                <div className="product__image">

                                                    <img
                                                   height="300px !important"
                                                   style={{
                                                     height : "300px !important"
                                                   }}
                                                        src={course.image_path} />

                                                </div>
                                            </NavLink>


                                            <div className="product__content">
                                                <div className="product__info">

                                                    <NavLink className=""
                                                        to={`/course?id=${course.id}`}>
                                                        <h4 className="product__title"
                                                        >
                                                            {course.name}</h4>
                                                    </NavLink>


                                                    <div className="progress">
                                                        <div className="progress__outer">

                                                            <div className="progress__inner" style={{ width: (course.userprogresscount / course.lessonscount) * 100 + "%" }}></div>
                                                        </div>
                                                    </div>



                                                    <p className="product__body"
                                                        kjb-settings-id="sections_1596053467662_settings_color_body_text">
                                                    </p>

                                                </div>
                                                <div className="product__button">
                                                    <NavLink className="btn btn--outline btn--medium btn--auto"
                                                        to={`/course?id=${course.id}`}
                                                        state={{ image: course.image_path }}
                                                        >
                                                        View Class
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            {/* { allCourses?.length != courses.length ? (
                                <h3 className="products__title mt-5 mb-3"
                                kjb-settings-id="sections_1596053467662_settings_text_heading">Additional Courses
                            </h3>
                            ) : null} */}
                                    

                         {/* {
                            allCourses?.map((course:any)=>{
                                let findCourse = courses?.find((c: any) => c.id == course.id);
                              
                                if(!findCourse) {
                                    return(
                                        <div className="col-12 products__col">


                                        <div className="product product--12 box-shadow-medium  background-light">

                                            <a className="" onClick={()=>{goToWhatsapp(`${course.name.split("-").pop()}  اريد الاشتراك فى كورس`)}}>
                                                
                                                <div className="product__image">

                                                    <img
                                                          height="300px !important"
                                                          style={{
                                                            height : "300px !important"
                                                          }}
                                                        src={course.image_path} />

                                                </div>
                                            </a>


                                            <div className="product__content">
                                                <div className="product__info">

                                                    <a className="" onClick={()=>{goToWhatsapp(`${course.name.split("-").pop()}  اريد الاشتراك فى كورس`)}} >
                                                        <h4 className="product__title"
                                                        >
                                                            {course.name}</h4>
                                                    </a>
                                                    <p className="product__body"
                                                        kjb-settings-id="sections_1596053467662_settings_color_body_text">
                                                    </p>

                                                </div>
                                                <div className="product__button" onClick={()=>{goToWhatsapp(`${course.name.split("-").pop()}  اريد الاشتراك فى كورس`)}}>
                                                    <a className="btn btn--outline btn--medium btn--auto" >  
                                                        Know more 
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )

                                }

                            })
                         } */}




                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}


export default Courses